<template>
    <span class="acc-add">
        <button-tooltip icon x-small top :tooltip="tooltip" buttonClass="acc-add-btn" @click="$emit('click')">
            <v-icon :size="size" color="accent">{{ icon }}</v-icon>
        </button-tooltip>
    </span>
</template>

<script>
import ButtonTooltip from './ButtonTooltip.vue'

export default {
    name: "AccordionAddButton",
    components: { ButtonTooltip },
    props: {
        tooltip: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: '$plus'
        },
        size: {
            type: [String, Number],
            default: '18'
        }
    }
}
</script>

<style scoped>
.acc-add {
    display: inline-flex;
}

.acc-add >>> .acc-add-btn {
    width: 26px !important;
    height: 26px !important;
    min-width: 26px !important;
    border-radius: 50% !important;
    border: 1px solid var(--v-outline2-base) !important;
    background: var(--v-surface-base) !important;
}
</style>
